import {TipoDePagamentoEnum} from "./TipoDePagamentoEnum";
import {FormaDePagamento} from "./FormaDePagamento";

export class Pagamento {
  formaDePagamento: FormaDePagamento;
  trocoPara: number;
  temTroco: string;
  valor: number;
  removido: boolean;
  constructor(public id: number = null) {
    this.trocoPara = 0.00;
  }

  ehPagamentoEmDinheiro() {
    return this.formaDePagamento.nome === TipoDePagamentoEnum.Dinheiro;
  }
}
